import { SvgIcon } from "../../containers/Shared";

export const FilterChipItem = ({ filter, onClearFilter }) => {
  return (
    <div key={filter.key} className={`qi-filter-chip`}>
      <span className="qi-filter-chip_label" title={filter.label}>
        {filter?.label} :{" "}
      </span>
      <span className="qi-filter-chip_value" title={filter.value}>
        {filter?.value}
      </span>
      <SvgIcon
        name="cross"
        title="Remove filter"
        onClick={() => onClearFilter(filter)}
        wrapperClass="action-btn"
        svgClass="icon-cross"
      />
    </div>
  );
};
